import { Result as AntdResult, ResultProps } from "antd";
import React from "react";

const Result = (props: ResultProps) => {
  return <AntdResult {...props} />;
};

export default Result;
